<template>
<div>
    <a-modal
      :title="modalState.title"
      :visible="modalState.visible"
     :confirm-loading="confirmLoading"
     width="400px"
      @cancel="handleCancel"
    >
        <a-form-model 
            :model="modalState" 
            ref="ruleForm" 
            :rules="rules" 
            :layout="formItemLayout" 
            :label-col="labelCol" 
            :wrapper-col="wrapperCol"
        >
            <a-form-model-item ref="name" label="菜单名" prop="name" >
                <a-input
                    v-model="modalState.name"
                    aria-placeholder="请输入菜单名"
                     @blur="
                        () => {
                            $refs.name.onFieldBlur();
                        }
                        "
                />
            </a-form-model-item>

            <a-form-model-item ref="url" label="路径URL" prop="url" >
                <a-input
                    v-model="modalState.url"
                    aria-placeholder="请输入URL"
                     @blur="
                        () => {
                            $refs.url.onFieldBlur();
                        }
                        "
                />
            </a-form-model-item>

            <a-form-model-item ref="remark" label="备注" prop="remark" >
                <a-input
                    v-model="modalState.remark"
                    aria-placeholder="请输入备注，例如：版本号v1  分支号0915"
                     @blur="
                        () => {
                            $refs.remark.onFieldBlur();
                        }
                        "
                />
            </a-form-model-item>

            <a-form-model-item ref="subname" label="副标题" prop="subname" >
                <a-input
                    v-model="modalState.subname"
                    aria-placeholder="请输入副标题"
                    
                />
            </a-form-model-item>

            <a-form-model-item ref="ordernum" label="排序" prop="ordernum" >
                <a-input
                    v-model="modalState.ordernum"
                    aria-placeholder="请输入排序号"
                   
                />
            </a-form-model-item>

            <a-form-model-item ref="icon" label="图标名" prop="icon" >
                <a-input
                    v-model="modalState.icon"
                    aria-placeholder="请输入图标名"
                   
                />
            </a-form-model-item>
 
        </a-form-model>
     <template slot="footer">
        <a-button key="back" @click="handleCancel">
          取消
        </a-button>
        <a-button key="submit" type="primary" :loading="confirmLoading" @click="handleOk">
          保存
        </a-button>
      </template>
    </a-modal>
  </div>
  
</template>
<script>

export default {
    data() {
        return {
            labelCol: { span: 6 },
            wrapperCol: { span: 14 },
            rules: {
                name: [
                    { required: true, message: '请填写菜单名', trigger: 'blur' },
                ],
                url: [
                    { required: true, message: '请填写URL', trigger: 'blur' },
                ],
                remark:[
                    { required: true, message: '请填写备注', trigger: 'blur' },
                ],
            },
            confirmLoading: false,
            formItemLayout:'inline',
            modalState:{
                visible:false,
            }
        };
    },
    computed: {

    },
    props:{
        
    },
    methods: {
        onModalInit(item){
            let that = this;
            that.modalState = {
                visible:true,
                ...item
            }
        },
        handleOk() {
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    console.log(this.modalState);
                    this.confirmLoading = true;
                    if(this.modalState.id){
                        //编辑
                        this.$store
                            .dispatch({
                                type: "usercenter/addEditMenu",
                                params: this.modalState
                            })
                            .then((response) => {
                                console.log(response)
                                this.modalState.visible = false;
                                this.$emit('onModalHide');
                                this.confirmLoading = false;
                            });
                    }
                    else{
                        //新增
                        this.$store
                            .dispatch({
                                type: "usercenter/addEditMenu",
                                params: this.modalState
                            })
                            .then((response) => {
                                console.log(response)
                                if(response.data.success == '1'){
                                    this.modalState.visible = false;
                                    this.$emit('onModalHide');
                                }
                                this.confirmLoading = false;
                     
                            });
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
            
        },

        handleCancel(e) {
            e.preventDefault()
            this.resetForm();
            this.modalState.visible = false;
            this.$emit('onModalHide');
        },
        resetForm() {
            this.$refs.ruleForm.resetFields();
        },
    },
};
</script>

<style scoped>
.ant-form-inline .ant-form-item{
    width:100%;
}
</style>
